import { render } from "./ExportBtns.vue?vue&type=template&id=2b9a8c15&scoped=true"
import script from "./ExportBtns.vue?vue&type=script&lang=js"
export * from "./ExportBtns.vue?vue&type=script&lang=js"

import "./ExportBtns.vue?vue&type=style&index=0&id=2b9a8c15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9a8c15"]])

export default __exports__